import Markdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import remarkGfm from "remark-gfm";
import { getMarkdownComponents } from "./markdown-components";

type MarkdownRendererClientProps = {
  content: string;
  onPageClick?: (pageId: string) => void;
};

export function MarkdownRendererClient({ content, onPageClick }: MarkdownRendererClientProps) {
  const components = getMarkdownComponents(onPageClick);

  return (
    <div className="text-xs text-foreground">
      <Markdown
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeHighlight]}
        components={components}
      >
        {content}
      </Markdown>
    </div>
  );
}
